module.exports = __webpack_public_path__ + "img/Comic_58.824b41ff.png";